import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
routes: [
    {
        path: '/',
        component: resolve => require(['@/views/Index.vue'], resolve),
        redirect: '/index',
        children:[
            {
              path: 'index', 
              name: 'index',
              component: resolve => require(['@/views/Index.vue'], resolve)
            }
        ]
    },
    {
       path: '/cma',
        component: resolve => require(['@/components/Layout.vue'], resolve),
        redirect: '/cma/2020-2021',
        children:[
            {
              path: '2020-2021', 
              name: 'cma_2020-2021',
              component: resolve => require(['@/views/cma2020-2021.vue'], resolve)
            },
            {
              path: '2019', 
              name: 'cma_2019',
              component: resolve => require(['@/views/cma2019.vue'], resolve)
            },
            {
              path: 'finalist', 
              name: 'finalist',
              component: resolve => require(['@/views/finalist.vue'], resolve)
            },
            {
              path: 'old/:id', 
              name: 'cma_old',
              component: resolve => require(['@/views/cmaOld.vue'], resolve)
            },
            {
              path: 'expert/:id', 
              name: 'cma_expert',
              component: resolve => require(['@/views/cmaExpert.vue'], resolve)
            },
            {
              path: 'introduce', 
              name: 'cma_introduce',
              component: resolve => require(['@/views/cmaIntroduce.vue'], resolve)
            },
            {
              path: 'member', 
              name: 'cma_member',
              component: resolve => require(['@/views/cmaMember.vue'], resolve)
            },
            {
              path: 'organization', 
              name: 'cma_organization',
              component: resolve => require(['@/views/cmaOrganization.vue'], resolve)
            },
            {
              path: 'contact', 
              name: 'cma_contact',
              component: resolve => require(['@/views/cmaContact.vue'], resolve)
            },
            {
              path: 'activity', 
              name: 'cma_activity',
              component: resolve => require(['@/views/cmaActivity.vue'], resolve)
            },
            {
              path: 'news', 
              name: 'cma_news',
              component: resolve => require(['@/views/cmaNews.vue'], resolve)
            },
            {
              path: 'notice', 
              name: 'notice',
              component: resolve => require(['@/views/notice.vue'], resolve)
            },
            {
              path: 'applyList', 
              name: 'applyList',
              component: resolve => require(['@/views/applyList.vue'], resolve)
            }
        ]
    }
]
})
